import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AddUsersToRouteParams, MbapiAdminService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useCreateRoute = (
  extraOptions?: UseMutationOptions<void, AxiosError, AddUsersToRouteParams>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async body => {
      await MbapiAdminService.mbapiAdminControllerAddUsersOnRoute({ body });
    },
    {
      ...extraOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries([QueryKeys.getAllRoutes]);
        extraOptions?.onSuccess?.(data, variables, context);
      },
    }
  );
};
